/*
  Copyright (C) 2022 - Jeci SARL - https://jeci.fr

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see https://www.gnu.org/licenses/agpl-3.0.html.
 */
import {
  ActionsApi,
  ActivitiesApi,
  AlfrescoApi,
  AspectsApi,
  AuthenticationApi,
  CategoriesApi,
  CommentsApi,
  ContentApi,
  DownloadsApi,
  DiscoveryApi,
  FavoritesApi,
  GroupsApi,
  NodesApi,
  PeopleApi,
  PreferencesApi,
  RenditionsApi,
  SearchApi,
  SharedlinksApi,
  SitesApi,
  TagsApi,
  TrashcanApi,
  TypesApi,
  UploadApi,
  VersionsApi,
  WebscriptApi,
} from "@alfresco/js-api";

export const alfrescoApi = new AlfrescoApi();

export const contentApi = new ContentApi(alfrescoApi);

export const uploadApi = new UploadApi(alfrescoApi);

export const renditionsApi = new RenditionsApi(alfrescoApi);

export const nodesApi = new NodesApi(alfrescoApi);

export const sitesApi = new SitesApi(alfrescoApi);

export const searchApi = new SearchApi(alfrescoApi);

export const peopleApi = new PeopleApi(alfrescoApi);

export const preferencesApi = new PreferencesApi(alfrescoApi);

export const favoritesApi = new FavoritesApi(alfrescoApi);

export const trashcanApi = new TrashcanApi(alfrescoApi);

export const groupsApi = new GroupsApi(alfrescoApi);

export const sharedLinksApi = new SharedlinksApi(alfrescoApi);

export const versionsApi = new VersionsApi(alfrescoApi);

export const actionsApi = new ActionsApi(alfrescoApi);

export const categoriesApi = new CategoriesApi(alfrescoApi);

export const commentsApi = new CommentsApi(alfrescoApi);

export const downloadsApi = new DownloadsApi(alfrescoApi);

export const tagsApi = new TagsApi(alfrescoApi);

export const aspectsApi = new AspectsApi(alfrescoApi);

export const typesApi = new TypesApi(alfrescoApi);

export const webscriptApi = new WebscriptApi(alfrescoApi);

export const activitiesApi = new ActivitiesApi(alfrescoApi);

export const discoveryApi = new DiscoveryApi(alfrescoApi);

export const authenticationApi = new AuthenticationApi(alfrescoApi);
